import { render } from "./ViewBiodata.vue?vue&type=template&id=c95be6b8"
import script from "./ViewBiodata.vue?vue&type=script&lang=js"
export * from "./ViewBiodata.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MY PROJECTS\\Vue 3 Project\\MarriageBeauroWeb\\marriage_beauro_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__